<template>
  <div>
    <div v-if="playItem == null">
      <v-row>
        <v-col xs12 sm2>
          <v-select
            v-bind:items="['All'].concat(categories)"
            v-model="category"
            label="Select"
            light
            single-line
            auto
            item-text="name"
            item-value="name"
          />
        </v-col>
        <v-col xs12 sm10 class="text-xs-right" style="font-size: 1.5em; padding-top: 1em;">總瀏覽次數： {{ totalCount }}</v-col>
      </v-row>

      <section class="mb-5 bg--white"
        v-for="categoryArea in categories.filter((el) => { return category === 'All' || (category !== 'All' && el === category) })"
        :key="categoryArea.name">
        <v-row>
          <v-col xs10>
            <h4>{{ categoryArea.name }} ({{ categoryArea.count }})</h4>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col xs12 sm4 v-for="place, index in filterPlace(categoryArea.name)" :key="index">
            <v-card @click="viewPlace(place)" style="cursor: pointer;">
              <div class="pa-1">
                <img :src="place.coverUrl" style="max-width: 100%; max-height: 300px;" />
              </div>

              <v-card-title primary-title>
                <div>
                  <div class="headline">{{ place.lessonName }}</div>
                  <span class="grey--text">觀看次數： {{ place.viewCount }}</span>
                </div>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </section>
    </div>

    <div class="container" v-else>
      <v-row>
        <v-col xs8>
          <h4>{{ playItem.lessonName }}</h4>
        </v-col>

        <v-col xs4 class="text-xs-right">
          <v-btn floating small primary class="pink" @click.native="playItem = null">X</v-btn>
        </v-col>
      </v-row>

      <Player ref="Player" :url="playItem.videoUrl" />
    </div>
  </div>
</template>

<script>
  import Player from 'live-player/dist/Player.js'
  import 'font-awesome/css/font-awesome.css'
  import { mapMutations } from 'vuex'
  import api from '../api'

  export default {

    name: 'placeList',

    components: {
      Player
    },

    data () {
      return {
        list: [],
        categories: [],
        category: 'All',
        playItem: null
      }
    },

    created () {
      this.initBreadcrumb()
      this.addBreadcrumb({
        text: '首頁',
        link: '/'
      })
      this.update()
    },

    computed: {
      totalCount () {
        let count = 0
        this.categories.forEach(function (el) {
          count += el.count
        })

        return count
      }
    },

    methods: {
      ...mapMutations([
        'addBreadcrumb',
        'initBreadcrumb'
      ]),

      async update () {
        const { data } = await api.Place.List()
        this.list = data.data

        let categories = this.list.slice(0)
        this.categories = categories.reduce(function (r, a) {
          r.map((el) => { return el.name }).indexOf(a.ciryArea) === -1 && r.push({'name': a.ciryArea, 'count': a.areaCount})
          return r
        }, [])
      },

      filterPlace (category) {
        return this.list.filter((el) => { return el.ciryArea === category })
      },

      viewPlace (place) {
        this.playItem = place
      }
    }
  }
</script>

<style lang="scss">
  span.btn {
    background-color: transparent;
    font-size: 1.5em;
  }

  .btn-sm {
    min-width: auto!important;
  }
</style>



// WEBPACK FOOTER //
// PlaceList.vue?02a7947b